// Little Hotelier is the single source of truth for rates & availability.
// The property page is the canonical booking-engine URL. The APAC vanity URL
// (apac.littlehotelier.com/properties/byerfountaindirect) redirects here but
// STRIPS the date query params during the redirect. So we hand off directly to
// the canonical URL and Little Hotelier's booking engine picks up:
//   checkInDate / checkOutDate (camelCase)
//   items[][adults]  items[][children]  (array notation, one entry per room)
// Using the older snake_case params (check_in_date etc.) or hitting the vanity
// URL currently causes the property page to render as a 404 in some browsers.
const ENGINE = "https://book-directonline.com/properties/ByerFountainMotorInnDIRECT";

// Format a Date to YYYY-MM-DD using LOCAL date parts (NOT toISOString, which
// converts to UTC and can shift the day backwards in Australia/Sydney, UTC+10/+11).
const fmt = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt)) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// "Today" anchored to Australia/Sydney so past-date prevention is correct regardless of the visitor's timezone.
export function sydneyToday() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Australia/Sydney",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t).value;
  return new Date(Number(get("year")), Number(get("month")) - 1, Number(get("day")));
}

export function buildBookingUrl({ checkIn, checkOut, adults, children, rooms, promo } = {}) {
  const p = new URLSearchParams();
  const ci = fmt(checkIn);
  const co = fmt(checkOut);
  if (ci) p.set("checkInDate", ci);
  if (co) p.set("checkOutDate", co);
  // Little Hotelier expects items as an array — one entry per room, each with adults & children.
  const roomsCount = Math.max(1, Number(rooms) || 1);
  for (let i = 0; i < roomsCount; i++) {
    p.append("items[][adults]", String(Math.max(1, Number(adults) || 1)));
    p.append("items[][children]", String(Math.max(0, Number(children) || 0)));
  }
  if (promo) p.set("promoCode", promo);
  const qs = p.toString();
  return qs ? `${ENGINE}?${qs}` : ENGINE;
}

export function openBooking(params) {
  const url = buildBookingUrl(params);
  // Navigate the current tab straight to the booking engine so guests see
  // only one page — the direct booking engine — instead of leaving our site
  // open in a second tab.
  window.location.href = url;
  return url;
}

export { ENGINE };
